import {
  TransferPart,
  TransferPartsDataResponse,
} from 'src/store/models/ShoppingCartModels'
import { store } from 'store'
import OsnServiceProvider from '../../../../src/services/OsnServiceProvider'
import { StoreInstances } from 'src/store/StoreInstancesContainer'

const createHiddenInput = (name: string, id: string, value: string) => {
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = name
  input.id = id
  input.value = String(value)
  return input
}

export const submitTransferPartsForm = (
  dataPayload: string,
  formUrlToSubmit: string
): void => {
  const form = document.createElement('form')

  form.appendChild(
    createHiddenInput('cxml-urlencoded', 'oracleCart', dataPayload)
  )

  form.method = 'POST'

  form.action = formUrlToSubmit
  form.hidden = true
  document.body.appendChild(form)
  form.submit()
}

export const transferAllCarts = (
  token: string
): Promise<TransferPartsDataResponse | undefined> => {
  const transferParts: TransferPart[] = []

  store.getState().cart.cartData.vehicles.forEach((v) => {
    v.sellers.forEach((s) => {
      s.locations.forEach((l) => {
        l.parts.forEach((p) => {
          // shoppingCartProducts.push(p)
          const selectedLocation = p.location.find(
            (loc) => loc.locationId.toString() === l.locationId.toString()
          )
          if (!selectedLocation) {
            return
          }
          transferParts.push({
            unitPrice: selectedLocation.cost.toString(),
            manufacturerPartId: '',
            selectedLoc: selectedLocation.called,
            classificationDomain: 'UNSPSC',
            unitCore: selectedLocation.coreCost.toString(),
            categoryCodeIdentifier: 'SUPPLIER',
            manufacturerName: p.manufacturerName || '',
            lineCode: p.lineCode,
            uom: !selectedLocation.originalUom
              ? 'EA'
              : selectedLocation.originalUom,
            packNumUnits: selectedLocation.packNumUnits.toString(),
            partDescription: p.description || '',
            lineType: 'GOODS',
            qty: p.quantityRequested.toString(),
            partNumber: p.partNumber,
            currency:
              StoreInstances.userStore.country?.countryId === 1 ? 'CAD' : 'USD',
          })
        })
      })
    })
  })

  const transferPartsDataResponse: Promise<
    TransferPartsDataResponse | undefined
  > = OsnServiceProvider.transferCartParts({ partsdata: transferParts }, token)

  return transferPartsDataResponse
}
